module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('toolbar', {
    class: _vm.section
  }), _vm._v(" "), (_vm.$city) ? _c('city') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1ff92f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 298
// module chunks = 1